<template>
  <section class="mcu-attachments">
    <header>
      <div><small>DOKUMEN HASIL</small><strong>Lampiran MCU & hasil penunjang</strong><p>PDF atau gambar disimpan privat dengan checksum dan jejak audit.</p></div>
    </header>
    <clinical-file-upload
      v-if="editable && recordId"
      class="mt-3"
      accept="application/pdf,image/jpeg,image/png,image/webp"
      :disabled="uploading"
      :browse-text="uploading ? 'Mengunggah…' : 'Pilih file'"
      hint="PDF atau gambar hasil pemeriksaan"
      @change="upload"
    ></clinical-file-upload>
    <b-alert v-if="errorMessage" show variant="danger" class="mt-2 mb-0">{{ errorMessage }}</b-alert>
    <div v-if="!recordId" class="mcu-attachments__empty">Simpan draft registrasi MCU terlebih dahulu sebelum mengunggah hasil.</div>
    <div v-else-if="items.length" class="mcu-attachments__list">
      <article v-for="item in items" :key="item.id">
        <span><i :class="item.extension === 'pdf' ? 'fas fa-file-pdf' : 'fas fa-file-image'"></i></span>
        <div><strong>{{ item.title || item.original_name }}</strong><small>{{ item.file_size_human }} · {{ dateTime(item.captured_at) }}</small></div>
        <button type="button" @click="open(item)">Buka</button>
        <button v-if="editable" type="button" class="danger" @click="voidItem(item)">Batalkan</button>
      </article>
    </div>
    <div v-else class="mcu-attachments__empty">Belum ada lampiran hasil MCU.</div>
  </section>
</template>

<script>
import ApiService from "@/core/services/api.service.js";

export default {
  name: "McuResultAttachments",
  props: { recordId: { type: [Number, String], default: null }, editable: { type: Boolean, default: false } },
  data: () => ({ items: [], uploading: false, errorMessage: "" }),
  watch: { recordId: { immediate: true, handler(value) { if (value) this.load(); else this.items = []; } } },
  methods: {
    async load() {
      try {
        const response = await ApiService.get(`vertical-clinical/records/${this.recordId}/media`);
        this.items = (response.data.data || []).filter(item => ["mcu_result", "mcu_supporting"].includes(item.media_role));
      } catch (e) { this.errorMessage = this.error(e); }
    },
    async upload(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file || !this.recordId) return;
      if (file.size > 26214400) { this.errorMessage = "Ukuran file maksimal 25 MB."; return; }
      this.uploading = true; this.errorMessage = "";
      const body = new FormData();
      body.append("file", file); body.append("media_role", "mcu_result"); body.append("title", file.name);
      body.append("reason", "Unggah dokumen hasil atau pemeriksaan penunjang MCU.");
      try { await ApiService.post(`vertical-clinical/records/${this.recordId}/media`, body); await this.load(); }
      catch (e) { this.errorMessage = this.error(e); }
      finally { this.uploading = false; }
    },
    async open(item) {
      try {
        const response = await ApiService.query(item.content_endpoint, { responseType: "blob" });
        const url = URL.createObjectURL(response.data); window.open(url, "_blank", "noopener");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (e) { this.errorMessage = this.error(e); }
    },
    async voidItem(item) {
      const reason = window.prompt("Alasan pembatalan lampiran:");
      if (!reason || reason.trim().length < 5) return;
      try { await ApiService.post(`vertical-clinical/media/${item.id}/void`, { reason }); await this.load(); }
      catch (e) { this.errorMessage = this.error(e); }
    },
    dateTime(value) { return value ? this.$clinicDateTime(value) : "-"; },
    error(e) { const d = e && e.response && e.response.data; return (d && (d.message || d.error)) || e.message || "Lampiran belum dapat diproses."; },
  },
};
</script>

<style scoped>
.mcu-attachments { grid-column: 1 / -1; padding: .9rem; border: 1px solid #cde9e6; border-radius: 12px; background: #f8fdfc; }
.mcu-attachments header { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.mcu-attachments header small, .mcu-attachments header strong, .mcu-attachments header p { display: block; margin: 0; }
.mcu-attachments header small { color: #0f766e; font-size: .62rem; font-weight: 800; letter-spacing: .08em; }
.mcu-attachments header p, .mcu-attachments__empty { color: #64748b; font-size: .7rem; }
.mcu-attachments input { display: none; }
.mcu-attachments__list { display: grid; gap: .45rem; margin-top: .8rem; }
.mcu-attachments article { display: grid; grid-template-columns: auto minmax(0,1fr) auto auto; align-items: center; gap: .65rem; padding: .6rem; border: 1px solid #dbe7ef; border-radius: 9px; background: #fff; }
.mcu-attachments article > span { color: #0f766e; font-size: 1.2rem; }
.mcu-attachments article strong, .mcu-attachments article small { display: block; }
.mcu-attachments article small { color: #64748b; font-size: .64rem; }
.mcu-attachments article button { border: 0; background: transparent; color: #0f766e; font-size: .7rem; font-weight: 800; }
.mcu-attachments article button.danger { color: #b91c1c; }
.mcu-attachments__empty { margin-top: .7rem; padding: .8rem; border: 1px dashed #bdd8d5; border-radius: 9px; text-align: center; }
</style>
